// extracted by mini-css-extract-plugin
export default {"blackBg":"K69MxMWGBuflIpHhEpXW","container":"NKhgRD6eNkGcgwk6sjay"};